export const userVisitsArchiveTypes = {
  POST_USER_VISITS_DATA: 'POST_USER_VISITS_DATA',
  POST_USER_VISITS_DATA_SUCCESS: 'POST_USER_VISITS_DATA_SUCCESS',

  EXPORT_USER_VISITS_DATA: 'EXPORT_USER_VISITS_DATA',
  EXPORT_USER_VISITS_DATA_SUCCESS: 'EXPORT_USER_VISITS_DATA_SUCCESS',

  MAKE_IS_FETCHING_TRUE: 'MAKE_IS_FETCHING_TRUE',
  MAKE_EXPORT_IS_FETCHING_TRUE: 'MAKE_EXPORT_IS_FETCHING_TRUE',
};
